module.exports = __webpack_public_path__ + "img/24_42.87cbcd1a.png";